// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ReconDetails Component Styles */

.recon-details-container {
  background-color: #f8f9fa;
  height: 100vh;
}

.recon-sidebar {
  min-width: 200px !important;
  background: white;
  border-right: 1px solid #dee2e6;
  overflow-y: auto;
}

/* Page Header */
.page-header {
  background: white;
  padding: 1rem 0;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

/* Transaction Detail Card */
.transaction-detail-card {
  /* background: linear-gradient(135deg, #fff3cd 0%, #ffeaa7 100%);
  border-left: 4px solid #ffc107; */
  border-radius: 12px;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.transaction-detail-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

.detail-item {
  padding: 0.5rem;
  background: rgba(255, 255, 255, 0.7);
  border-radius: 8px;
  transition: background-color 0.2s ease;
}

.detail-item:hover {
  background: rgba(255, 255, 255, 0.9);
}

.detail-label {
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 0.25rem;
  display: block;
}

.detail-value {
  font-size: 0.75rem;
  color: #495057;
  line-height: 1.3;
}

.status-badge {
  font-size: 0.75rem;
  padding: 0.35rem 0.65rem;
  border-radius: 20px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.header-icon {
  color: #0d6efd;
  font-size: 1.1rem;
}

.product-row:hover {
  background-color: #f8f9fa;
}

.product-name {
  font-weight: 500;
  color: #495057;
}

.gst-badge {
  background-color: #e3f2fd;
  color: #1976d2;
  padding: 0.25rem 0.5rem;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 600;
}

.delivery-row {
  background-color: #f8f9fa;
}

.subtotal-row {
  font-weight: 600;
  background-color: #e9ecef !important;
}

.summary-row {
  border-bottom: 1px solid #dee2e6;
  transition: background-color 0.2s ease;
}

.summary-row:hover {
  background-color: rgba(13, 110, 253, 0.05);
  border-radius: 4px;
  margin: 0 -0.5rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.summary-row:last-child {
  border-bottom: none;
}

.summary-label {
  color: #6c757d;
  font-weight: 500;
  font-size: 12px;
}

.summary-value {
  color: #495057;
  font-size: 12px;
}

.total-amount {
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
  border-radius: 8px;
  padding: 0.5rem !important;
  margin: 0 -0.5rem;
  font-size: 14px;
}

/* Recon Message Cards */
.recon-message-card {
  border-left: 4px solid #0d6efd;
}

.info-label {
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.5px;
  margin-bottom: 0.25rem;
  display: block;
}

.info-value {
  font-size: 12px;
  color: #495057;
  font-weight: 500;
}

.settlement-row:hover {
  background-color: #f8f9fa;
}

.settlement-id,
.payment-id {
  font-family: "Courier New", monospace;
  font-size: 0.8rem;
  color: #6c757d;
}

.ref-no {
  font-family: "Courier New", monospace;
  font-size: 0.8rem;
  color: #495057;
  font-weight: 500;
}

.settlement-date {
  font-size: 0.8rem;
  color: #6c757d;
}

/* Responsive Design */
@media (max-width: 768px) {
  .recon-details-container {
    padding: 0.5rem;
  }

  .transaction-detail-card {
    margin: 0 -0.5rem;
  }

  .detail-item {
    margin-bottom: 0.75rem;
  }

  .card-header {
    padding: 1rem;
  }

  .card-body {
    padding: 1rem;
  }

  .order-table,
  .settlement-table {
    font-size: 0.8rem;
  }

  .order-table th,
  .order-table td,
  .settlement-table th,
  .settlement-table td {
    padding: 0.5rem 0.25rem;
  }

  .action-buttons {
    flex-direction: column;
    gap: 0.75rem;
  }

  .btn-action {
    width: 100%;
  }
}

@media (max-width: 576px) {
  .detail-value {
    font-size: 0.85rem;
  }

  .status-badge {
    font-size: 0.7rem;
    padding: 0.25rem 0.5rem;
  }

  .message-info {
    padding: 1rem;
  }

  .taxes-summary {
    padding: 1rem;
  }
}

/* Animation for loading states */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.card,
.transaction-detail-card {
  animation: fadeIn 0.5s ease-out;
}

/* Custom scrollbar for tables */
.table-responsive::-webkit-scrollbar {
  height: 8px;
}

.table-responsive::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.table-responsive::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

.table-responsive::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* Focus states for accessibility */
.btn-action:focus,
.breadcrumb-item a:focus {
  outline: 2px solid #0d6efd;
  outline-offset: 2px;
}

/* Print styles */
@media print {
  .action-buttons {
    display: none;
  }

  .card {
    box-shadow: none;
    border: 1px solid #dee2e6;
  }

  .transaction-detail-card {
    background: white !important;
  }
}

.tabs-container {
  display: flex;
  justify-content: flex-start; /* Align tabs to the left */
  gap: 15px;
  margin-bottom: 20px;
  overflow-x: auto;
}

.tab-btn {
  background-color: #f1f1f1;
  padding: 5px 15px;
  border: 1px solid #ddd;
  border-radius: 30px; /* Rounded corners */
  cursor: pointer;
  font-size: 14px;
  color: #333;
  transition: all 0.3s ease;
  text-align: center;
  white-space: nowrap;
}

.tab-btn:hover {
  background-color: #0056b3;
  color: white;
  border-color: #0056b3;
}

.tab-btn.active {
  background-color: #007bff; /* Active tab color */
  color: white;
  font-weight: bold;
  border-color: #007bff;
  box-shadow: 0 4px 8px rgba(0, 123, 255, 0.3); /* Active tab shadow */
}

.tab-btn:focus {
  outline: none; /* Remove the default focus outline */
}

@media (max-width: 768px) {
  .tabs-container {
    flex-wrap: wrap; /* Make tabs responsive on smaller screens */
  }
  .tab-btn {
    flex: 1 1 auto;
    min-width: 100px; /* Prevent tabs from being too small */
  }
}

/* .recon-sidebar {
  width: 100%;
  max-height: 300px;
} */

.list-item {
  cursor: pointer;
  transition: all 0.2s ease;
  border-bottom: 1px solid #f8f9fa;
}

.list-item:hover {
  background-color: #f8f9fa;
}

.list-item.active {
  background-color: rgba(13, 110, 253, 0.1);
  border-left: 4px solid #0d6efd;
}

.delivery-summary {
  font-size: 12px;
  line-height: 1.6;
}

.modal-backdrop {
  background-color: transparent !important;
 backdrop-filter: blur(10px);
-webkit-backdrop-filter: blur(10px);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1050;
}

.modal-dialog {
  background: white;
  border-radius: 8px;
  max-width: 400px;
  width: 100%;
  box-shadow: 0 4px 15px rgba(0,0,0,0.2);
  padding: 20px;
}`, "",{"version":3,"sources":["webpack://./src/containers/Recons/ReconDetails.css"],"names":[],"mappings":"AAAA,kCAAkC;;AAElC;EACE,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA,4BAA4B;AAC5B;EACE;mCACiC;EACjC,mBAAmB;EACnB,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,oCAAoC;EACpC,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,gCAAgC;EAChC,sCAAsC;AACxC;;AAEA;EACE,0CAA0C;EAC1C,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,6DAA6D;EAC7D,kBAAkB;EAClB,0BAA0B;EAC1B,iBAAiB;EACjB,eAAe;AACjB;;AAEA,wBAAwB;AACxB;EACE,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,qCAAqC;EACrC,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;;;;IAIE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,iCAAiC;AACjC;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA,gCAAgC;AAChC;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,mCAAmC;AACnC;;EAEE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,aAAa;EACb,2BAA2B,EAAE,2BAA2B;EACxD,SAAS;EACT,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB,EAAE,oBAAoB;EACzC,eAAe;EACf,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,yBAAyB,EAAE,qBAAqB;EAChD,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;EACrB,4CAA4C,EAAE,sBAAsB;AACtE;;AAEA;EACE,aAAa,EAAE,qCAAqC;AACtD;;AAEA;EACE;IACE,eAAe,EAAE,4CAA4C;EAC/D;EACA;IACE,cAAc;IACd,gBAAgB,EAAE,sCAAsC;EAC1D;AACF;;AAEA;;;GAGG;;AAEH;EACE,eAAe;EACf,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;EACzC,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;CACzC,2BAA2B;AAC5B,mCAAmC;EACjC,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,sCAAsC;EACtC,aAAa;AACf","sourcesContent":["/* ReconDetails Component Styles */\n\n.recon-details-container {\n  background-color: #f8f9fa;\n  height: 100vh;\n}\n\n.recon-sidebar {\n  min-width: 200px !important;\n  background: white;\n  border-right: 1px solid #dee2e6;\n  overflow-y: auto;\n}\n\n/* Page Header */\n.page-header {\n  background: white;\n  padding: 1rem 0;\n  border-radius: 8px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n/* Transaction Detail Card */\n.transaction-detail-card {\n  /* background: linear-gradient(135deg, #fff3cd 0%, #ffeaa7 100%);\n  border-left: 4px solid #ffc107; */\n  border-radius: 12px;\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.transaction-detail-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);\n}\n\n.detail-item {\n  padding: 0.5rem;\n  background: rgba(255, 255, 255, 0.7);\n  border-radius: 8px;\n  transition: background-color 0.2s ease;\n}\n\n.detail-item:hover {\n  background: rgba(255, 255, 255, 0.9);\n}\n\n.detail-label {\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin-bottom: 0.25rem;\n  display: block;\n}\n\n.detail-value {\n  font-size: 0.75rem;\n  color: #495057;\n  line-height: 1.3;\n}\n\n.status-badge {\n  font-size: 0.75rem;\n  padding: 0.35rem 0.65rem;\n  border-radius: 20px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n}\n\n.header-icon {\n  color: #0d6efd;\n  font-size: 1.1rem;\n}\n\n.product-row:hover {\n  background-color: #f8f9fa;\n}\n\n.product-name {\n  font-weight: 500;\n  color: #495057;\n}\n\n.gst-badge {\n  background-color: #e3f2fd;\n  color: #1976d2;\n  padding: 0.25rem 0.5rem;\n  border-radius: 12px;\n  font-size: 0.75rem;\n  font-weight: 600;\n}\n\n.delivery-row {\n  background-color: #f8f9fa;\n}\n\n.subtotal-row {\n  font-weight: 600;\n  background-color: #e9ecef !important;\n}\n\n.summary-row {\n  border-bottom: 1px solid #dee2e6;\n  transition: background-color 0.2s ease;\n}\n\n.summary-row:hover {\n  background-color: rgba(13, 110, 253, 0.05);\n  border-radius: 4px;\n  margin: 0 -0.5rem;\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n}\n\n.summary-row:last-child {\n  border-bottom: none;\n}\n\n.summary-label {\n  color: #6c757d;\n  font-weight: 500;\n  font-size: 12px;\n}\n\n.summary-value {\n  color: #495057;\n  font-size: 12px;\n}\n\n.total-amount {\n  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);\n  border-radius: 8px;\n  padding: 0.5rem !important;\n  margin: 0 -0.5rem;\n  font-size: 14px;\n}\n\n/* Recon Message Cards */\n.recon-message-card {\n  border-left: 4px solid #0d6efd;\n}\n\n.info-label {\n  font-size: 14px;\n  font-weight: 700;\n  letter-spacing: 0.5px;\n  margin-bottom: 0.25rem;\n  display: block;\n}\n\n.info-value {\n  font-size: 12px;\n  color: #495057;\n  font-weight: 500;\n}\n\n.settlement-row:hover {\n  background-color: #f8f9fa;\n}\n\n.settlement-id,\n.payment-id {\n  font-family: \"Courier New\", monospace;\n  font-size: 0.8rem;\n  color: #6c757d;\n}\n\n.ref-no {\n  font-family: \"Courier New\", monospace;\n  font-size: 0.8rem;\n  color: #495057;\n  font-weight: 500;\n}\n\n.settlement-date {\n  font-size: 0.8rem;\n  color: #6c757d;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .recon-details-container {\n    padding: 0.5rem;\n  }\n\n  .transaction-detail-card {\n    margin: 0 -0.5rem;\n  }\n\n  .detail-item {\n    margin-bottom: 0.75rem;\n  }\n\n  .card-header {\n    padding: 1rem;\n  }\n\n  .card-body {\n    padding: 1rem;\n  }\n\n  .order-table,\n  .settlement-table {\n    font-size: 0.8rem;\n  }\n\n  .order-table th,\n  .order-table td,\n  .settlement-table th,\n  .settlement-table td {\n    padding: 0.5rem 0.25rem;\n  }\n\n  .action-buttons {\n    flex-direction: column;\n    gap: 0.75rem;\n  }\n\n  .btn-action {\n    width: 100%;\n  }\n}\n\n@media (max-width: 576px) {\n  .detail-value {\n    font-size: 0.85rem;\n  }\n\n  .status-badge {\n    font-size: 0.7rem;\n    padding: 0.25rem 0.5rem;\n  }\n\n  .message-info {\n    padding: 1rem;\n  }\n\n  .taxes-summary {\n    padding: 1rem;\n  }\n}\n\n/* Animation for loading states */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.card,\n.transaction-detail-card {\n  animation: fadeIn 0.5s ease-out;\n}\n\n/* Custom scrollbar for tables */\n.table-responsive::-webkit-scrollbar {\n  height: 8px;\n}\n\n.table-responsive::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 4px;\n}\n\n.table-responsive::-webkit-scrollbar-thumb {\n  background: #c1c1c1;\n  border-radius: 4px;\n}\n\n.table-responsive::-webkit-scrollbar-thumb:hover {\n  background: #a8a8a8;\n}\n\n/* Focus states for accessibility */\n.btn-action:focus,\n.breadcrumb-item a:focus {\n  outline: 2px solid #0d6efd;\n  outline-offset: 2px;\n}\n\n/* Print styles */\n@media print {\n  .action-buttons {\n    display: none;\n  }\n\n  .card {\n    box-shadow: none;\n    border: 1px solid #dee2e6;\n  }\n\n  .transaction-detail-card {\n    background: white !important;\n  }\n}\n\n.tabs-container {\n  display: flex;\n  justify-content: flex-start; /* Align tabs to the left */\n  gap: 15px;\n  margin-bottom: 20px;\n  overflow-x: auto;\n}\n\n.tab-btn {\n  background-color: #f1f1f1;\n  padding: 5px 15px;\n  border: 1px solid #ddd;\n  border-radius: 30px; /* Rounded corners */\n  cursor: pointer;\n  font-size: 14px;\n  color: #333;\n  transition: all 0.3s ease;\n  text-align: center;\n  white-space: nowrap;\n}\n\n.tab-btn:hover {\n  background-color: #0056b3;\n  color: white;\n  border-color: #0056b3;\n}\n\n.tab-btn.active {\n  background-color: #007bff; /* Active tab color */\n  color: white;\n  font-weight: bold;\n  border-color: #007bff;\n  box-shadow: 0 4px 8px rgba(0, 123, 255, 0.3); /* Active tab shadow */\n}\n\n.tab-btn:focus {\n  outline: none; /* Remove the default focus outline */\n}\n\n@media (max-width: 768px) {\n  .tabs-container {\n    flex-wrap: wrap; /* Make tabs responsive on smaller screens */\n  }\n  .tab-btn {\n    flex: 1 1 auto;\n    min-width: 100px; /* Prevent tabs from being too small */\n  }\n}\n\n/* .recon-sidebar {\n  width: 100%;\n  max-height: 300px;\n} */\n\n.list-item {\n  cursor: pointer;\n  transition: all 0.2s ease;\n  border-bottom: 1px solid #f8f9fa;\n}\n\n.list-item:hover {\n  background-color: #f8f9fa;\n}\n\n.list-item.active {\n  background-color: rgba(13, 110, 253, 0.1);\n  border-left: 4px solid #0d6efd;\n}\n\n.delivery-summary {\n  font-size: 12px;\n  line-height: 1.6;\n}\n\n.modal-backdrop {\n  background-color: transparent !important;\n backdrop-filter: blur(10px);\n-webkit-backdrop-filter: blur(10px);\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1050;\n}\n\n.modal-dialog {\n  background: white;\n  border-radius: 8px;\n  max-width: 400px;\n  width: 100%;\n  box-shadow: 0 4px 15px rgba(0,0,0,0.2);\n  padding: 20px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
